<!--
  Copyright 2024 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="loi-properties-dialog-container">
  <div mat-dialog-title class="loi-icon-and-title">
    <mat-icon svgIcon="{{ iconName }}" [ngStyle]="{color: iconColor}"></mat-icon>

    <div>{{ loiDisplayName }}</div>

    <button class="close" mat-icon-button mat-dialog-close aria-label="close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <mat-list>
      <ng-container *ngFor="let property of properties | keyvalue; let lastItem = last;">
        <mat-list-item>
          <div class="mat-list-item-content">
            <div>{{property.key}}</div>

            <div>{{property.value}}</div>
          </div>
        </mat-list-item>

        <mat-divider *ngIf="!lastItem"></mat-divider>
      </ng-container>
    </mat-list>
  </mat-dialog-content>
</div>
